import type { ITheme } from "./contexts/ThemeContext";

export const theme: ITheme = {
    palette: {
        primary: {
            main: '#81A63F',
            light: '#7DA339',
            dark: '#5E752E',
            contrastText: '#EAF0FF',
        },
        secondary: {
            main: '#0F1B2E',
            light: '#0E1A2B',
            dark: '#0B1220',
            contrastText: '#EAF0FF',
        },
        error: {
            main: 'rgb(255, 0, 0)',
            light: 'rgb(255, 57, 57)',
            dark: 'rgb(200, 0, 0)',
            contrastText: 'rgb(0, 0, 0)',
        },
        success: {
            main: '#81A63F',
            light: '#7DA339',
            dark: '#5E752E',
            contrastText: '#EAF0FF',
        },
        divider: 'rgba(255, 255, 255, 0.10)'
    },
    background: {
        default: '#0B1220',
        paper: '#0F1B2E',
        panel: '#0F1B2E',
        card: '#0E1A2B',
    },
    text: {
        primary: '#EAF0FF',
        secondary: '#A9B4CC',
        disabled: '#808080',
        muted: '#A9B4CC',
    },
    colors: {
        green: {
            g1: '#81A63F',
            g2: '#7DA339',
            g3: '#5E752E',
        },
        accent: {
            korea: '#2F6BFF',
            egypt: '#E6C35A',
        },
        line: 'rgba(255,255,255,0.10)',
    },
    borderRadius: {
        r1: '14px',
        r2: '22px',
    },
    shadow: {
        shadow1: '0 10px 30px rgba(0,0,0,0.35)',
    }
}